import { render, staticRenderFns } from "./SimpleDialog.vue?vue&type=template&id=0db5cc14&scoped=true"
import script from "./SimpleDialog.vue?vue&type=script&lang=ts"
export * from "./SimpleDialog.vue?vue&type=script&lang=ts"
import style0 from "./SimpleDialog.vue?vue&type=style&index=0&id=0db5cc14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db5cc14",
  null
  
)

export default component.exports